import { boolean, number, object, string, array } from 'yup';

export const cashReceiptsMemberSchema = object({
    id: number().required(),
    dimension: number().required(),
    income: string().required(),
    name: string().required(),
    position: string().required()
});

export const noticePeriodMemberSchema = object({
    id: number().required(),
    description: string().required(),
    name: string().required(),
    confirmation: boolean().nullable()
});

export const chosenSourceDetailsSchema = object({
    amount: string().required(),
    chosenSource: number().required(),
    note: string().nullable(),
    members: array().of(number())
});
